import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { CustomerCartModel } from 'src/models/customer/cartModel';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/Cart';
const cartType = 0;

export const CustomerCartServicess = {
  getData: async (dataId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getCartByCustomerId?customerId=${dataId}&cartType=${cartType}`
      );
      return response.data as CustomerCartModel;
    } catch (error) {
      throw error;
    }
  },

  addNewCartData: async (data) => {
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, data);
      enqueueSnackbar(` Service added successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },

  addServiceToCart: async (dataId, data) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/addServiceToCart?cartId=${dataId}`,
        data
      );
      enqueueSnackbar(` Service added successfully`, {
        variant: 'success'
      });
      return response.data;
    } catch (error) {
      enqueueSnackbar(` Service can't be added`, {
        variant: 'error'
      });
    }
  },

  addSubscriptionToCart: async (dataId, data) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/addSubscriptionToCart?cartId=${dataId}`,
        data
      );
      enqueueSnackbar(` Subscription added successfully`, {
        variant: 'success'
      });
      return response.data;
    } catch (error) {
      enqueueSnackbar(` Service can't be added`, {
        variant: 'error'
      });
    }
  },

  updateCartServices: async (data: any) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateCartService`,
        data
      );
      enqueueSnackbar(` Service updated successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },

  updateCartSubscription: async (data: any) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateCartSubscription`,
        data
      );
      enqueueSnackbar(` Subscription updated successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },

  removeServiceFromCart: async (dataId: number) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/removeServiceFromCart?cartServiceId=${dataId}`
      );
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },

  removeSubscriptionFromCart: async (dataId: number) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/removeSubscriptionFromCart?cartSubscriptionId=${dataId}`
      );
      enqueueSnackbar(` Subscription removed from cart successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },

  deleteData: async (dataId: number) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${dataId}`
      );
      enqueueSnackbar(` Removed from Cart successfully`, {
        variant: 'success'
      });
      return response.data as CustomerCartModel[];
    } catch (error) {
      throw error;
    }
  },
  getById: async (dataId: number) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?id=${dataId}`
      );
      return response.data as CustomerCartModel;
    } catch (error) {
      throw error;
    }
  },
};
